import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  SettingsManageUsersRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { SettingsListStaffUsersScreen } from "./SettingsListStaffUsersScreen";
import { SettingsCreateStaffMemberScreen } from "./SettingsCreateStaffMemberScreen";
import { SettingsEditStaffMemberScreen } from "./SettingsEditStaffMemberScreen";
import { SettingsUpgradeStaffToUserAccountScreen } from "./SettingsUpgradeStaffToUserAccountScreen";

export type SettingsManageUsersRootScreen = StackScreenProps<
  SettingsRootParamList,
  "SettingsManageUsersRootScreen"
>;

export const SettingsManageUsersRootScreen = ({
  navigation,
}: SettingsManageUsersRootScreen) => {
  const Stack = createStackHeaderNavigator<SettingsManageUsersRootParamList>();

  return (
    <Stack.Navigator
      screenOptions={{
        animationEnabled: true,
      }}
    >
      <Stack.Group
        screenOptions={{
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          title: "",
        }}
      >
        <Stack.Screen
          name="SettingsListStaffUsersScreen"
          component={SettingsListStaffUsersScreen}
        />
        <Stack.Screen
          name="SettingsCreateStaffMemberScreen"
          component={SettingsCreateStaffMemberScreen}
        />
        <Stack.Screen
          name="SettingsEditStaffMemberScreen"
          component={SettingsEditStaffMemberScreen}
        />
        <Stack.Screen
          name="SettingsUpgradeStaffToUserAccountScreen"
          component={SettingsUpgradeStaffToUserAccountScreen}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};
